import { getCustomCode } from 'client/scripts/views/reactViews/ApiUtil';
import BootstrapData from './models/BootstrapData';
import Global from 'models/Global';
import config from 'config';
import FeatureToggleUtils from 'FeatureToggleUtils';

export const loadCustomCode = async({ serverRendered }) => {
    let siteConf, event;
    if (serverRendered){
        siteConf = BootstrapData('bootstrap-data-siteConf');
        event = BootstrapData('bootstrap-data-event');
    } else {
        const siteConfModel = Global?.get?.('siteConf');
        const eventModel = Global?.get?.('event');
        siteConf = siteConfModel?.toJSON?.() || {};
        event = eventModel?.toJSON?.() || {};
    }
    const { tabs, currentTab, enableCustomCode } = siteConf || {};

    const tabByType = tabs?.find?.(tab => tab.type === currentTab);
    const tabById = tabs?.find?.(tab => tab.id === currentTab);
    const currentTabData = tabByType || tabById;

    if (enableCustomCode) {
        if (serverRendered) {
            loadServerRenderedCustomCode({siteConf, currentTabData, event});
        } else {
            loadClientRenderedCustomCode({siteConf, currentTabData, event});
        }
    }

};

const loadServerRenderedCustomCode = async({siteConf, currentTabData, event}) => {
    const eventId = event.id;
    const accountId = event['account-id'];
    const tabId = currentTabData?.id;
    const prefixUrl = `https://s3.amazonaws.com/${config.s3ResourcesBucket}/events/files/${accountId}/${eventId}`;
    try {
        let fetchedTabCustomCode;
        const SSR_tabCustomCode = BootstrapData('bootstrap-data-tabCustomCode');
        if (SSR_tabCustomCode && Object.keys(SSR_tabCustomCode).length !== 0){
            fetchedTabCustomCode = SSR_tabCustomCode;
        } else {
            if (currentTabData) {
                fetchedTabCustomCode = await getCustomCodeSnippets(({scope: currentTabData}));
            }
        }
        createNewPageCustomCustomCodeElement({
            customCode: fetchedTabCustomCode?.footerCustomCodeText,
            placement: 'footer',
            scope: 'page'
        });

    } catch (e) {
        console.log(e);
    }

    try {
        const SSR_globalCustomCode = BootstrapData('bootstrap-data-globalCustomCode');
        let fetchedGlobalCustomCode;
        if (SSR_globalCustomCode && Object.keys(SSR_globalCustomCode).length !== 0){
            fetchedGlobalCustomCode = SSR_globalCustomCode;
        } else {
            if (siteConf) {
                fetchedGlobalCustomCode = await getCustomCodeSnippets(({scope: siteConf}));
            }
        }
        createNewPageCustomCustomCodeElement({
            customCode: fetchedGlobalCustomCode.footerCustomCodeText,
            placement: 'footer',
            scope: 'global'
        });

    } catch (e) {
        console.log(e);
    }

    const solutionsInternalCodeEnabled = FeatureToggleUtils.isFeatureEnabled('solution-internal-code');
    try {
        const SSR_tabInternalCustomCode = BootstrapData('bootstrap-data-tabInternalCustomCode');
        let fetchedTabIntrenalCustomCode;
        if (solutionsInternalCodeEnabled) {
            if (SSR_tabInternalCustomCode && Object.keys(SSR_tabInternalCustomCode).length !== 0){
                fetchedTabIntrenalCustomCode = SSR_tabInternalCustomCode;
            } else {
                const tabIntrenalConfig = {
                    headerCustomCodeUrl: `${prefixUrl}/${tabId}/CustomCodeHeaderInternal.html`,
                    headerCustomCodeEnable: true,
                    footerCustomCodeUrl: `${prefixUrl}/${tabId}/CustomCodeFooterInternal.html`,
                    footerCustomCodeEnable: true
                };
                fetchedTabIntrenalCustomCode = await getCustomCodeSnippets(({scope: tabIntrenalConfig}));
            }
            createNewPageCustomCustomCodeElement({
                customCode: fetchedTabIntrenalCustomCode.footerCustomCodeText,
                placement: 'footer',
                scope: 'global',
                internal: true
            });
        }
    } catch (e) {
        console.log(e);
    }
    try {
        const SSR_globalInternalCustomCode = BootstrapData('bootstrap-data-globalInternalCustomCode');
        let fetchedGlobalIntrenalCustomCode;
        if (solutionsInternalCodeEnabled) {
            if (SSR_globalInternalCustomCode && Object.keys(SSR_globalInternalCustomCode).length !== 0){
                fetchedGlobalIntrenalCustomCode = SSR_globalInternalCustomCode;
            } else {
                const globalIntrenalConfig = {
                    headerCustomCodeUrl: `${prefixUrl}/CustomCodeHeaderInternal.html`,
                    headerCustomCodeEnable: true,
                    footerCustomCodeUrl: `${prefixUrl}/CustomCodeFooterInternal.html`,
                    footerCustomCodeEnable: true
                };
                fetchedGlobalIntrenalCustomCode = await getCustomCodeSnippets(({scope: globalIntrenalConfig}));
            }
            createNewPageCustomCustomCodeElement({
                customCode: fetchedGlobalIntrenalCustomCode.footerCustomCodeText,
                placement: 'footer',
                scope: 'global',
                internal: true
            });
        }
    } catch (e) {
        console.log(e);
    }
};
const loadClientRenderedCustomCode = async({siteConf, currentTabData, event}) => {
    removeCustomCodeElements();
    const eventId = event.id;
    const accountId = event['account-id'];
    const tabId = currentTabData?.id;
    const prefixUrl = `https://s3.amazonaws.com/${config.s3ResourcesBucket}/events/files/${accountId}/${eventId}`;
    try {
        if (currentTabData) {
            const fetchedTabCustomCode = await getCustomCodeSnippets(({scope: currentTabData}));
            createNewPageCustomCustomCodeElement({customCode: fetchedTabCustomCode.headerCustomCodeText, placement: 'header', scope: 'page'});
            createNewPageCustomCustomCodeElement({customCode: fetchedTabCustomCode.footerCustomCodeText, placement: 'footer', scope: 'page'});
        }
    } catch (e) {
        console.log(e);
    }
    try {
        if (siteConf) {
            const fetchedGlobalCustomCode = await getCustomCodeSnippets({scope: siteConf});
            createNewPageCustomCustomCodeElement({ customCode: fetchedGlobalCustomCode?.headerCustomCodeText, placement: 'header', scope: 'global' });
            createNewPageCustomCustomCodeElement({ customCode: fetchedGlobalCustomCode?.footerCustomCodeText, placement: 'footer', scope: 'global'});
        }
    } catch (e) {
        console.log(e);
    }
    try {
        const globalIntrenalConfig = {
            headerCustomCodeUrl: `${prefixUrl}/CustomCodeHeaderInternal.html`,
            headerCustomCodeEnable: true,
            footerCustomCodeUrl: `${prefixUrl}/CustomCodeFooterInternal.html`,
            footerCustomCodeEnable: true
        };
        const fetchedGlobalInternalCustomCode = await getCustomCodeSnippets({scope: globalIntrenalConfig});
        createNewPageCustomCustomCodeElement({ customCode: fetchedGlobalInternalCustomCode?.headerCustomCodeText, placement: 'header', scope: 'global', internal: true });
        createNewPageCustomCustomCodeElement({ customCode: fetchedGlobalInternalCustomCode?.footerCustomCodeText, placement: 'footer', scope: 'global', internal: true });
    } catch (e) {
        console.log(e);
    }
    try {
        const tabIntrenalConfig = {
            headerCustomCodeUrl: `${prefixUrl}/${tabId}/CustomCodeHeaderInternal.html`,
            headerCustomCodeEnable: true,
            footerCustomCodeUrl: `${prefixUrl}/${tabId}/CustomCodeFooterInternal.html`,
            footerCustomCodeEnable: true
        };
        const fetchedTabInternalCustomCode = await getCustomCodeSnippets(({scope: tabIntrenalConfig}));
        createNewPageCustomCustomCodeElement({customCode: fetchedTabInternalCustomCode.headerCustomCodeText, placement: 'header', scope: 'page', internal: true});
        createNewPageCustomCustomCodeElement({customCode: fetchedTabInternalCustomCode.footerCustomCodeText, placement: 'footer', scope: 'page', internal: true});
    } catch (e) {
        console.log(e);
    }
};


const getCustomCodeSnippets = async({scope = {}}) => {
    const footerCustomCodeUrl = scope.footerCustomCodeEnable && scope.footerCustomCodeUrl;
    const headerCustomCodeUrl = scope.headerCustomCodeEnable && scope.headerCustomCodeUrl;
    const headerCustomCodeText = headerCustomCodeUrl && await getCustomCode({customCodeUrl: headerCustomCodeUrl}) || {};
    const footerCustomCodeText = footerCustomCodeUrl && await getCustomCode({customCodeUrl: footerCustomCodeUrl}) || {};
    return {
        headerCustomCodeText: headerCustomCodeText.customCode,
        footerCustomCodeText: footerCustomCodeText.customCode
    };

};

const createNewPageCustomCustomCodeElement = ({customCode, placement, scope, internal}) => {
    if (!customCode) {
        return;
    }
    const tag = placement === 'header' ? 'head' : 'body';
    placement = internal ? `${placement}-internal` : placement;
    const newPageCustomCode = `<noscript class="${scope}-${placement}-custom-code-opener"></noscript>${customCode}<noscript class="${scope}-${placement}-custom-code-closer"></noscript>`;
    $(tag).append(newPageCustomCode);

};

const removeCustomCodeElements = () => {
    getCustomCodeElements({placement: 'header', scope: 'page'})?.remove();
    getCustomCodeElements({placement: 'footer', scope: 'page'})?.remove();
    getCustomCodeElements({placement: 'footer', scope: 'global'})?.remove();
    getCustomCodeElements({placement: 'header', scope: 'global'})?.remove();
    getCustomCodeElements({placement: 'header-internal', scope: 'page'})?.remove();
    getCustomCodeElements({placement: 'footer-internal', scope: 'page'})?.remove();
    getCustomCodeElements({placement: 'footer-internal', scope: 'global'})?.remove();
    getCustomCodeElements({placement: 'header-internal', scope: 'global'})?.remove();
};

const getCustomCodeElements = ({placement, scope}) => {
    const pageCustomCodeScopeOpenerElements = document.getElementsByClassName(`${scope}-${placement}-custom-code-opener`);
    const pageCustomCodeScopeCloserElements = document.getElementsByClassName(`${scope}-${placement}-custom-code-closer`);
    const foundPageCustomCodeScopeOpenerElements = pageCustomCodeScopeOpenerElements && pageCustomCodeScopeOpenerElements.length > 0;
    const foundPageCustomCodeScopeCloserElements = pageCustomCodeScopeCloserElements && pageCustomCodeScopeCloserElements.length > 0;
    if (foundPageCustomCodeScopeOpenerElements && foundPageCustomCodeScopeCloserElements) {
        const parentTag = placement === 'header' ? 'head' : 'body';
        const parent = $(parentTag);
        const parentChildren = parent.children();
        const openerIndex = parentChildren.index(pageCustomCodeScopeOpenerElements[0]);
        const closerIndex = parentChildren.index(pageCustomCodeScopeCloserElements[0]) +1;
        return parentChildren.slice(openerIndex, closerIndex);
    }
    return null;
};
